import View from "ln/view/View";
import Node from "ln/node/Node";
import Template from "ln/template/TemplateManager";
import VideoPlayer from "../VideoPlayer";
import List from "ln/list/List";
import ListRenderer from "ln/list/ListRenderer";
import TimeMonitor from "../TimeMonitor";
import PropertyTween from "ln/animation/PropertyTween";


export interface ChapterInterface{
    time:number,
    text:string,
    previewImage:string
}

class ChapterControl extends View{

    private chapterList:ListRenderer<ChapterInterface>;
    private monitor:TimeMonitor;
    private animation:PropertyTween;

    constructor( public player:VideoPlayer ){
        super();

        this.defaultTemplate = 'lv.video-chapter-control';

        // register on the player to show active item
        this.player.time.add( this.setCurrentChapter, this );

        this.monitor = new TimeMonitor();
        this.player.time.add( this.monitor.update.bind( this.monitor ) );

    }

    public init(){
        
        this.chapterList = new ListRenderer<ChapterInterface>( this.node.js( 'chapteritems' ) );
        this.chapterList.defaultRender( ( chapter:ChapterInterface ) => {

            let chapterItem = Node.fromHTML( Template.render( 'lv.video-chapter-item', chapter ) );
            chapterItem.click.add( () => {
                this.player.moveToTime( chapter.time );
                this.player.play();
            });

            return { node: chapterItem, data: chapter };
        });

        this.monitor.start.add( this.scrollToCurrent, this );

        this.animation = new PropertyTween( this.node.js( 'chapteritems' ).native );

    }

    public addChapter( chapter:ChapterInterface ){
        ( this.chapterList.source as List<ChapterInterface> ).append( chapter )
    }

    public setChapters( chapters:ChapterInterface[] ){
        this.chapterList.source = new List<ChapterInterface>( chapters );
        this.monitor.setEvents( this.createChapterEvents( chapters ) );
    }

    private setCurrentChapter( time:number ){
        this.chapterList.links.all().forEach( ( chapter, index, chapters ) => {
            let active:boolean;
            if( index <= chapters.length - 2 ){
                active = chapter.item.time <= time && chapters[index + 1].item.time > time;    
            } else {
                active = chapter.item.time <= time;
            }
            chapter.node.toggleClass( '-current', active );
        });
    }

    private createChapterEvents( chapters:ChapterInterface[] ){
        let chapterEvents = [];
        this.chapterList.links.all().forEach( ( chapter, index, chapters ) => {
            if( index <= chapters.length - 2 ){
                chapterEvents.push({ startTime: chapter.item.time, endTime: chapters[index + 1].item.time, chapter } );
            } else {
                chapterEvents.push( { startTime: chapter.item.time, endTime: this.player.video.duration, chapter: chapter } );
            }
        });
        return chapterEvents;
    }

    private scrollToCurrent( monitorEvent ){
        let chapterContainer = this.node.js( 'chapteritems' );
        let index = this.chapterList.links.index( this.chapterList.linkOf( monitorEvent.chapter.item ) );
        // let max = this.node.js( 'chapteritems' ).bounds().width
        let left = 0;
        for( let i = 0; i < index; i++ ){
            left += this.chapterList.links.all()[i].node.bounds().width;
        }

        // scroll logic
        //if( left <= chapterContainer.native.scrollLeft && chapterContainer.native.scrollLeft < chapterContainer.native.scrollWidth - chapterContainer.bounds().width ){
            this.animation.to( { 'scrollLeft': Math.max( Math.min( this.node.js( 'chapteritems' ).native.scrollWidth, left ), 0 ) }, 0.25 );
        //}

    }
}

export default ChapterControl;